import axios from "axios";

const getBaseUrl = () => {
  const originUrlContains = url => window.location.origin?.toString().indexOf(url) !== -1;

  if (originUrlContains('utv.vegvesen.no') || originUrlContains('localhost:')) {
    return 'https://timebestilling-api.utv.atlas.vegvesen.no';
  } else if (originUrlContains('test.vegvesen.no')) {
    return 'https://timebestilling-api.test.atlas.vegvesen.no';
  }
  return 'https://timebestilling-api.atlas.vegvesen.no';
}

const api = axios.create({
  baseURL: getBaseUrl()?.trim()
})

export default api